import EN_TRANSLATIONS from '@dadohr/shared/locales/en/translation.json';
import i18n from 'i18next';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';
import AdminApp from './AdminApp';
import './index.css';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: { en: { translation: EN_TRANSLATIONS } },
    lng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

ReactDOM.render(
  <Suspense fallback={null}>
    <AdminApp />
  </Suspense>,
  document.getElementById('root')
);
